import { gql } from 'graphql-tag';

// Mutation to start the registration export job
export const EXPORT_REGISTRATIONS = gql`
  mutation GetRegistrationsReport($input: EventRegistrationsInput!) {
    getRegistrationsReport(input: $input) {
      jobId
      message
    }
  }
`;

// Subscription to track export status
export const REGISTRATION_EXPORT_STATUS = gql`
  subscription RegistrationsExportStatus($jobId: String!) {
    registrationsExportStatus(jobId: $jobId) {
      jobId
      status
      progress
      filename
      recordCount
      error
    }
  }
`;

// Query to get download URL when complete
export const GET_REGISTRATION_EXPORT_DOWNLOAD_URL = gql`
  query GetRegistrationsExportDownloadUrl($jobId: String!) {
    getRegistrationsExportDownloadUrl(jobId: $jobId)
  }
`;
